
// src/modules/loading/state.js
export default {
    isLoading: false,
}